<template>
  <div>
    <div class="flex-col hidden md:flex">
      <DesktopView
        :property_tenure_options="property_tenure_options"
        :property_types="property_types"
        :show-modal="showModal"
        @update:propertyTypeId="propertyTypeId = $event"
        @update:tenureId="tenureId = $event"
        @update:minPrice="minPrice = $event"
        @update:maxPrice="maxPrice = $event"
        @update:numBed="numBed = $event"
        @update:numBath="numBath = $event"
        @toggle-modal="toggleModal"
        @close-modal="closeViewModal"
        @filter-parameters="handlePropertyFilters"
        @more-property-filters="handleMorePropertyFilters"
      />
    </div>
    <div class="flex flex-col md:hidden">
      <MobileView
        :property_tenure_options="property_tenure_options"
        :property_types="property_types"
        :show-modal="showModal"
        @toggle-modal="toggleModal"
        @close-modal="closeViewModal"
        @update:propertyTypeId="propertyTypeId = $event"
        @update:tenureId="tenureId = $event"
        @update:minPrice="minPrice = $event"
        @update:maxPrice="maxPrice = $event"
        @update:numBed="numBed = $event"
        @update:numBath="numBath = $event"
        @filter-parameters="handlePropertyFilters"
        @more-property-filters="handleMorePropertyFilters"
      />
    </div>
  </div>
</template>

<script>
import DesktopView from "./search-filters/DesktopView.vue";
import MobileView from "./search-filters/MobileView.vue";
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

export default {
  name: "SearchFilter",
  components: {
    DesktopView,
    MobileView,
  },
  emits: ["filter-parameters"],
  setup(_, { emit }) {
    const store = useStore();
    const base_url = store.state.baseUrl;
    const showModal = ref(false);
    const propertyTypeId = ref(null);
    const tenureId = ref(null);
    const minPrice = ref(null);
    const maxPrice = ref(null);
    const numBed = ref(null);
    const numBath = ref(null);
    const property_types = ref([]);
    const property_tenure_options = ref([]);
    const loading = ref(false);

    const isMobileView = computed(() => window.innerWidth <= 768);

    const getPropertyTypes = () => {
      axios
        .get(`${base_url}property-types`)
        .then((response) => {
          property_types.value = response.data.data;
        })
        .catch((error) => console.log(error));
    };

    const getPropertyTenureOptions = () => {
      axios
        .get(`${base_url}property-tenure-options`)
        .then((response) => {
          property_tenure_options.value = response.data.data;
        })
        .catch((error) => console.log(error));
    };

    const toggleModal = () => {
      showModal.value = !showModal.value;
    };

    const closeViewModal = () => {
      showModal.value = false;
    };

    const handleMorePropertyFilters = (filters) => {
      emit("filter-parameters", filters);
    };
    const handlePropertyFilters = (payload) => {
      emit("filter-parameters", payload);
    };

    onMounted(() => {
      getPropertyTypes();
      getPropertyTenureOptions();
    });

    return {
      propertyTypeId,
      tenureId,
      minPrice,
      maxPrice,
      numBed,
      numBath,
      property_types,
      property_tenure_options,
      loading,
      showModal,
      toggleModal,
      closeViewModal,
      handleMorePropertyFilters,
      handlePropertyFilters,
      isMobileView,
    };
  },
};
</script>

<style scoped>
/* Your styles here */
</style>
